import React from "react";

type ParagraphProps = {
  children: React.ReactNode;
  className?: string;
}

export function Paragraph({ children, className }: ParagraphProps ) {
	return (
		<p className={["text-gray-700 leading-[1.6] text-lg font-medium md:text-xl font-barlow group-hover:text-white", className ?? "", ].join(" ")}>
			{children}
		</p>
	);
}
